<template>
    <a :href="item.url" class="bg-white shadow-md flex">
        <div class="w-1/4">
            <div class="bg-cover bg-center aspect-w-16 aspect-h-10" :style="styleCss(item.main_image)"></div>
        </div>
        <div class="flex-grow">
            <div class="p-4 xl:p-6 flex flex-col justify-between h-full">
                <div>
                    <div class="text-3xl font-serif font-bold text-blue leading-tight">{{ item.title }}</div>
                    <div class="bg-blue p-2 inline-flex my-4 text-white font-bold text-sm">
                        {{ item.business_type.title }}
                    </div>
                </div>
                <div class="space-y-8">
                    <div class="flex flex-wrap space-x-6 leading-none items-center">
                        <div v-if="item.telephone">
                            <a :href="item.telephone" class="flex items-center">
                                <span class="icon-phone text-lg pr-3"></span> 
                                <span class="font-light">{{ item.telephone }}</span>
                            </a>
                        </div>                        
                        <div class="flex items-center" v-if="item.address">
                            <span class="icon-map text-lg pr-3"></span> 
                            <span class="font-light">{{ item.address }}</span>
                        </div>
                    </div>
                    <div class="flex flex-wrap items-center space-x-6 leading-none">
                        <a v-if="item.email" :href="'mailto:'+item.email" target="_blank"><span class="text-2xl icon-at"></span></a>
                        <a v-if="item.website" :href="item.website" target="_blank"><span class="text-2xl icon-globe-americas"></span></a>
                        <a v-if="item.facebook" :href="item.facebook" target="_blank"><span class="text-2xl icon-facebook"></span></a>
                        <a v-if="item.instagram" :href="item.instagram" target="_blank"><span class="text-2xl icon-instagram"></span></a>
                    </div>
                </div>             
            </div>
        </div>      
    </a>
</template>

<script>

export default {

    props: {
        'item': Object
    },


    methods: {
        styleCss(image) {
            let style = 'background-image: url("'+image.small+'");'
            if (image.focus_css) {
                style += 'background-position: '+image.focus_css+';'
            }
            return style
        }
    }

};
</script>